import { Login, Image, Form, MobileLogo } from './styled'

const Base = (ChildrenComponent) => {
  const ComponentBase = (props) => {
    return (
      <Login>
        <Image />
        <Form>
          <MobileLogo src="/logo-dato.png" alt="Dato Tecnologia" />
          <ChildrenComponent {...props} />
        </Form>
      </Login>
    )
  }

  return ComponentBase
}

export default Base
